import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin'
import { loginResource } from '@/services/auth.service'

import useGlobal from '@/composables/useGlobal'
import useCaptcha from '@utils/useCaptcha'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForm',
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const vueRecaptcha = defineAsyncComponent(() => import('vue3-recaptcha2'))

const nextParameterValue = new URLSearchParams(window.location.search).get('next')

const {
  key,
  form,
  recaptcha,
  captchaToken,
  recaptchaVerified,
  verify,
  reset,
} = useCaptcha()

const emit = __emit
const load = ref(false)
const { $t } = useGlobal()
const nonFieldErrors = ref("")
const email = ref("")
const username = ref("")
const password = ref("")

const toResetForm = () => {
  emit('changeForm', true)
}

const request = (sendData, control) => {
  if (captchaToken.value) {
    useSubmit(send({...sendData, recaptcha: captchaToken.value}, control), control)
  } else {
    verify()
  }
}

const send = async (sendData: any, control: any) => {
  try {
      load.value = true
      const { data: { item: { redirectLink } } } = (await loginResource.execute({}, {
        ...sendData,
      }))
      window.location.href = nextParameterValue || redirectLink
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}



const __returned__ = { vueRecaptcha, nextParameterValue, key, form, recaptcha, captchaToken, recaptchaVerified, verify, reset, emit, load, $t, nonFieldErrors, email, username, password, toResetForm, request, send, ref, defineAsyncComponent, get useSubmit() { return useSubmit }, get loginResource() { return loginResource }, get useGlobal() { return useGlobal }, get useCaptcha() { return useCaptcha } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})